// extracted by mini-css-extract-plugin
module.exports = {"customTag":"partnerDetails_customTag__3jbKP","customTagIcon":"partnerDetails_customTagIcon__5Xpr_"};